import { observable, action, computed } from 'mobx';
import axios from '../lib/axios';

class SearchStore {
  @observable searchTerm;
  @observable searchItems = [];
  @observable searching = false;

  @action search(searchTerm) {
    this.searchTerm = searchTerm;
    if (this.searchTerm.length > 3) {
      this.searching = true;

      axios.get(`/search/${this.searchTerm}`)
        .then((result) => {
          this.searchItems = result.data;
          this.searching = false;
        })
        .catch((error) => {
          this.searching = false;
        });

    }
    else
      this.searchItems = [];
  }

  @computed get hasResults() {
    return this.searchItems.length > 0;
  }
}

export default new SearchStore();



// WEBPACK FOOTER //
// ./src/stores/SearchStore.js